import React, { useEffect, useState } from "react";
import Place from "@/assets/place.png";
import Guide from "@/assets/guide.png";
import "./welcome.scss";
import { PageHeader } from "@/components/header/header.it";
import { useHistory } from "react-router-dom";
import { formatDay, formatTime } from "@/utils/helper";
import Footer from "../Footer/Footer.it";
import useSocket from "@/hooks/useSocket";
import { ESocketEvents } from "@/utils/api/sockets.enum";
import WaitingRoom from "../WaitingRoom/Waitingroom.it";
import { toast } from "react-toastify";
import WelcomeLoader from "../WelcomeLoader/WelcomeLoader";
import { eventRoomStore } from "../../stores/event";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { globalStore } from "@/stores/global";
import MapContainer from "@/components/MapContainer";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import HomeIcon from "@mui/icons-material/Home";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

const WelcomeIt = (props: any) => {
  globalStore.stopLoading();
  const { addSocketEvent, initializeSocket, emitEvent } = useSocket();
  const history = useHistory();
  const eventDetail = (props?.visit || {}) as any;
  const visit = props?.visit_id || eventDetail?.id;
  const eventid = eventDetail?.id;

  const extractVisitTokenFromLink = (link: string) => {
    if (!link) {
      return "";
    }

    try {
      const parsed = new URL(link, window.location.origin);
      const parts = parsed.pathname.split("/").filter(Boolean);
      return parts[parts.length - 1] || "";
    } catch {
      const noQuery = String(link).split("?")[0];
      const parts = noQuery.split("/").filter(Boolean);
      return parts[parts.length - 1] || "";
    }
  };

  const resolveRoleFromVisitLinks = () => {
    if (!Array.isArray(eventDetail?.visit_links)) {
      return "";
    }

    const currentPath = window.location.pathname;
    const currentParts = currentPath.split("/").filter(Boolean);
    const currentToken = currentParts[currentParts.length - 1] || "";
    if (!currentToken) {
      return "";
    }

    const match = eventDetail.visit_links.find((entry: any) => {
      const token = extractVisitTokenFromLink(entry?.link || "");
      return token === currentToken;
    });

    return String(match?.role || "").toLowerCase();
  };

  const buildIsoDateTime = (dateValue: any, timeValue: any) => {
    if (!dateValue || !timeValue) {
      return "";
    }

    const rawTime = String(timeValue);
    const normalizedTime = rawTime.length === 5 ? `${rawTime}:00` : rawTime;
    const candidate = `${dateValue}T${normalizedTime}`;
    const parsed = new Date(candidate);
    return Number.isNaN(parsed.getTime()) ? candidate : parsed.toISOString();
  };

  const user_type =
    String(eventDetail?.user_role || "").toLowerCase() ||
    resolveRoleFromVisitLinks() ||
    "residence";

  const eventTimeUtc =
    eventDetail?.time_in_utc ||
    (eventDetail?.date && eventDetail?.time
      ? buildIsoDateTime(eventDetail.date, eventDetail.time)
      : "");
  const participants = Array.isArray(eventDetail?.participants) ? eventDetail.participants : [];
  const inviteeDetails = eventDetail?.invitee || {};
  const [visitEnabled, setVisitEnabled] = useState(
    eventDetail?.visit_started ? eventDetail?.visit_started : false
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setwaiting] = useState(false);
  const [isRequestingPermissions, setIsRequestingPermissions] = useState(false);

  /**
   * Demande les permissions caméra/micro au navigateur.
   * Doit être appelé directement depuis un événement utilisateur (clic)
   * pour fonctionner sur iOS Safari/Chrome.
   */
  const requestMediaPermissions = async (): Promise<boolean> => {
    // Vérifier si l'API est disponible
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.warn("getUserMedia not supported");
      return true; // Continuer quand même (peut-être une ancienne version)
    }

    try {
      setIsRequestingPermissions(true);
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true
      });
      // Arrêter les tracks immédiatement (on veut juste la permission)
      stream.getTracks().forEach(track => track.stop());
      console.log("Media permissions granted");
      return true;
    } catch (error: any) {
      console.error("Media permission error:", error);

      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        toast.error(
          "Si prega di autorizzare l'accesso alla fotocamera e al microfono per partecipare al tour.",
          { autoClose: 10000 }
        );
      } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        toast.error(
          "Nessuna fotocamera o microfono rilevato. Controlla i tuoi dispositivi.",
          { autoClose: 10000 }
        );
      } else {
        toast.error(
          "Errore durante l'accesso alla fotocamera/microfono. Per favore riprova.",
          { autoClose: 10000 }
        );
      }
      return false;
    } finally {
      setIsRequestingPermissions(false);
    }
  };

  const JoinHandler = async (time: any) => {
    // Demander les permissions AVANT de continuer (important pour iOS)
    const hasPermissions = await requestMediaPermissions();
    if (!hasPermissions) {
      return; // Ne pas continuer si les permissions sont refusées
    }

    if (user_type == "host" || user_type == "admin" || user_type == "guide") {
      if (eventRoomStore.canStartVisit(time)) {
        history.push(`/meeting/${visit}`);
      } else {
        toast.error("Non sei autorizzato a partecipare prima di 20 minuti", {
          autoClose: 8000,
        });
      }
    } else {
      if (eventRoomStore.canStartVisit(time)) {
        setwaiting(true);
        setTimeout(() => {
          history.push(`/meeting/${visit}`);
        }, 5000);
      } else {
        toast.error(
          "Il tuo tour culturale non è ancora iniziato. Per favore aggiorna la pagina più tardi.",
          {
            autoClose: 8000
          }
        );
      }
    }
  };

  useEffect(() => {
    if(user_type === 'residence' || user_type === 'multiconnection' || user_type === 'invitee') {
      eventRoomStore.hasVisitStarted(false);
      sessionStorage.clear();
    }
  }, [user_type])

  // const JoinHandler = (time: any) => {
  //   if (user_type == "host") {
  //     if (eventRoomStore.canStartVisit(time)) {
  //       history.push(`/meeting/${visit}`);
  //     } else {
  //       toast.error("Non sei autorizzato a partecipare prima di 20 minuti");
  //     }
  //   } else {
  //       setwaiting(true);
  //       setTimeout(() => {
  //         history.push(`/meeting/${visit}`);
  //       }, 5000);
  //   }
  // };

  const ImageHandler = (link: any) => {
    let text = link;
    text = text.replace("file/d/", "uc?id=");
    text = text.split("/view?usp=");
    return text[0];
  };

  useEffect(() => {
    //VisitDetails(eventid);
    initializeSocket();
    emitEvent(ESocketEvents.JoinVisit, {
      visit_id: eventid,
      user_role: user_type,
    });
    addSocketEvent(ESocketEvents.StartVisit, (visitId) => {
      if (eventid == visitId) {
        !visitEnabled ? setVisitEnabled(true) : null;
      }
    });
  }, []);

  const residenceLat = eventDetail?.residence_latitude ?? eventDetail?.structure_details?.lat;
  const residenceLng = eventDetail?.residence_longitude ?? eventDetail?.structure_details?.lng;

  // Gurgaon Coordinates
  const guideLat = eventDetail?.guide_latitude ?? eventDetail?.guide_details?.lat;
  const guideLng = eventDetail?.guide_longitude ?? eventDetail?.guide_details?.lng;

  const filteredParticipants = participants.filter(
    (participant: any) => participant.user_role === "MultiConnection"
  );

  const filteredResidence = participants.filter(
    (participant: any) => participant.user_role === "Residence"
  );

  const filteredInvitee = participants.filter(
    (participant: any) => participant.user_role === "Invitee"
  );

  // Clé unique pour identifier cette session de visite
  const sessionKey = `tm_visit_session_${eventid}_${user_type}`;

  useEffect(() => {
    // Vérifier si c'est une reconnexion (même session/onglet)
    const existingSession = sessionStorage.getItem(sessionKey);
    
    filteredInvitee.forEach((invitee:any) => {
      if (invitee.status === "JOINED" && invitee.link === window.location.href) {
        // Si c'est la même session, permettre la reconnexion
        if (existingSession) {
          console.log("Reconnexion détectée pour invitee - même session");
          return;
        }
        // Sinon, c'est une tentative de double connexion depuis un autre appareil
        window.location.href = '/404';
      }
    });
    
    // Marquer cette session comme active
    sessionStorage.setItem(sessionKey, Date.now().toString());
  }, [filteredInvitee, sessionKey]);

  console.log(filteredResidence, eventDetail, 'filteredResidence');

  useEffect(() => {
    if(user_type === 'residence') {
      // Vérifier si c'est une reconnexion (même session/onglet)
      const existingSession = sessionStorage.getItem(sessionKey);
      
      if (filteredResidence[0]?.status === "JOINED" && user_type === 'residence') {
        // Si c'est la même session, permettre la reconnexion
        if (existingSession) {
          console.log("Reconnexion détectée pour résidence - même session");
          return;
        }
        // Sinon, c'est une tentative de double connexion depuis un autre appareil
        window.location.href = '/404';
      }
      
      // Marquer cette session comme active
      sessionStorage.setItem(sessionKey, Date.now().toString());
    }
  }, [filteredResidence, user_type, sessionKey]);

  return (
    <>
      {isWaiting ? (
        <WaitingRoom />
      ) : (
        <div className="welcome">
          <PageHeader
            user_type={user_type}
            ShowOffer={true}
            Showcontact={true}
          />
          <div
            className={
              user_type === "residence" ? "welcome-page" : "welcome-page-host"
            }
          >
            {isLoading ? (
              <WelcomeLoader />
            ) : (
              <>
                <div className="page-container">
                  <div className="page-main">
                    <div
                      className={
                        user_type === "residence" || user_type === "multiconnection"
                          ? "page-left-side"
                          : "page-left-side-host"
                      }
                    >
                      <img
                        src={
                          eventDetail?.visit_picture &&
                          eventDetail?.visit_picture.includes("http")
                            ? ImageHandler(eventDetail.visit_picture)
                            : Place
                        }
                      />
                    </div>
                    {user_type === "residence" && (
                      <MapContainer
                        coordinates={{
                          residence: { lat: residenceLat, lng: residenceLng },
                          guide: { lat: guideLat, lng: guideLng },
                        }}
                        eventDetail={eventDetail}
                      />
                    )}
                    {user_type === "multiconnection" && (
                      <MapContainer
                        coordinates={{
                          residence: { lat: residenceLat, lng: residenceLng },
                          guide: { lat: guideLat, lng: guideLng },
                        }}
                        eventDetail={eventDetail}
                      />
                    )}
                  </div>
                  <div className="page-main-right">
                    <div className="page-main-right-container">
                      <div className="welcome-header">
                        {user_type === "host" ? (
                          <div className="welcome-header-text">
                            Viaggio culturale
                          </div>
                        ) : (
                          <div className="welcome-header-text">
                            Il tuo viaggio culturale
                          </div>
                        )}
                        <p className="welcome-placename">
                          {eventDetail.visit_name}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 15,
                          }}
                        >
                          <div className="avatar">
                            <img
                              src={
                                eventDetail?.guide_picture &&
                                eventDetail?.guide_picture.includes("http")
                                  ? ImageHandler(eventDetail.guide_picture)
                                  : Guide
                              }
                              alt="Avatar"
                              className="avatar-image"
                            />
                          </div>
                          <span
                            style={{
                              fontSize: "1.2rem",
                              color: "#1E2028",
                            }}
                          >
                            {eventDetail?.guide_name}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="welcome-resident-block">
                          <span className="welcome-resident-text">
                            <span className="welcome-resident-icon">
                              {user_type == "host" ? (
                                <PermContactCalendarIcon />
                              ) : (
                                <HomeIcon />
                              )}
                            </span>
                            {user_type === "host"
                              ? "Host"
                              : user_type === "residence"
                              ? "Residence"
                              : user_type === "invitee"
                              ? "Invité"
                              : user_type === "admin"
                              ? "Admin"
                              : user_type}
                          </span>
                          <p className="welcome-resident">
                            {user_type == "residence"
                              ? eventDetail.residence_name
                              : user_type == "host"
                              ? eventDetail.host_name
                              : user_type == "invitee"
                              ? inviteeDetails?.name
                              : user_type == "admin"
                              ? eventDetail.admin_name
                              : filteredParticipants[0]?.user_name}
                          </p>
                        </div>
                        {user_type == "host" && (
                          <div className="welcome-resident-block">
                            <span className="welcome-resident-text">
                              <span className="welcome-resident-icon">
                                <HomeIcon />
                              </span>
                              {user_type === "host" && "Residence"}
                            </span>
                            <p className="welcome-resident">
                              {user_type == "host"
                                ? eventDetail.residence_name
                                : ""}
                              {eventDetail.new_visit_level && (
                                <span className="guide-welcome-content-header-new">
                                  {eventDetail.new_visit_level}
                                </span>
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="welcome-prescreen-date">
                        {/* <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            fontSize: "1.125rem",
                            color: "#1E2028",
                          }}
                        >
                          <CalendarMonthIcon />
                          {formatDay(
                            eventRoomStore.convertTimeFromUTC(eventDetail.time)
                          )}
                        </span> */}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            fontSize: "1.125rem",
                            color: "#1E2028",
                          }}
                        >
                          <WatchLaterIcon />
                          {formatTime(
                            eventRoomStore.convertTimeFromUTC(
                              eventTimeUtc
                            )
                          )}
                        </span>
                      </div>
                      {(user_type === "guide" || user_type === "Guide") && eventDetail.comments && (
                        <div style={{ 
                          marginTop: "1rem", 
                          marginBottom: "1rem", 
                          padding: "15px", 
                          backgroundColor: "#fff3cd", 
                          border: "1px solid #ffeeba", 
                          borderRadius: "8px",
                          color: "#856404"
                        }}>
                          <p style={{ fontWeight: "bold", fontSize: "1rem", marginBottom: "5px", display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ fontSize: "1.2em" }}>⚠️</span> Info Visite :
                          </p>
                          <p style={{ fontSize: "0.95rem", whiteSpace: "pre-wrap" }}>
                            {eventDetail.comments}
                          </p>
                        </div>
                      )}
                      <button
                        onClick={() => {
                          JoinHandler(eventTimeUtc);
                        }}
                        className="welcome-button"
                        disabled={isRequestingPermissions}
                      >
                        {isRequestingPermissions ? (
                          "Autorizzazione in attesa..."
                        ) : (
                          <>
                            Inizia il giro
                            <KeyboardArrowRightIcon />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="welcome-header">
                  <div className="welcome-header-text">Votre Vonage</div>
                  <p className="welcome-placename">{eventDetail.visit_name}</p>
                </div>
                <div className="welcome-content">
                  <div className="welcome-prescreen-absolute">
                    <div className="welcome-prescreen">
                      <div className="welcome-image">
                        <div className="welcome-image-name">
                          {eventDetail.guide_name}
                        </div>
                        <div className="welcome-image-place">
                          <img
                            src={
                              eventDetail?.visit_picture &&
                              eventDetail?.visit_picture.includes("http")
                                ? ImageHandler(eventDetail.visit_picture)
                                : Place
                            }
                          />
                        </div>
                        <div className="avatar">
                          <img
                            src={
                              eventDetail?.guide_picture &&
                              eventDetail?.guide_picture.includes("http")
                                ? ImageHandler(eventDetail.guide_picture)
                                : Guide
                            }
                            alt="Avatar"
                            className="avatar-image"
                          />
                        </div>
                        {user_type === 'residence' &&
                          <MapContainer
                            coordinates={{
                              residence: { lat: residenceLat, lng: residenceLng },
                              guide: { lat: guideLat, lng: guideLng },
                            }}
                          />
                        }
                      </div>
                      <div>
                        <span className="welcome-resident-text">Residence</span>
                        <p className="welcome-resident">
                          {user_type == "residence"
                            ? eventDetail.residence_name
                            : eventDetail.host_name}
                        </p>
                        <div className="welcome-prescreen-date">
                          <p>
                            {formatDay(
                              eventRoomStore.convertTimeFromUTC(
                                eventDetail.time
                              )
                            )}
                          </p>
                          <p>
                            {formatTime(
                              eventRoomStore.convertTimeFromUTC(
                                eventDetail.time_in_utc
                              )
                            )}
                          </p>
                        </div>
                        <button
                          onClick={() => {
                            JoinHandler(eventDetail.time_in_utc);
                          }}
                          className="welcome-button"
                          // disabled={!visitEnabled}
                        >
                          Démarrez la visite
                          <KeyboardArrowRightIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </>
            )}
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};
export default WelcomeIt;
